module.exports = __webpack_public_path__ + "media/images/pc/brands/an/_main-visual-text-d02ab04d8d62e61443c5b5f3cb69a352.svg";